import React, { useEffect, useState } from "react";
import ShoulderPress from "components/animation/hero/ShoulderPress";
import ClientImgs from "assets/images/svg/clients.svg";
import { motion, AnimatePresence } from "framer-motion";
import ClientsImg from "assets/images/clients.jpg";
import test1 from "assets/images/test1.jpg";
import test2 from "assets/images/test2.jpg";
import test3 from "assets/images/test3.jpg";
import test4 from "assets/images/test4.jpg";
import test5 from "assets/images/test5.jpg";
const images = [test1, test2, test3, test4, test5];
const contantTest = [
  {
    name: "John Doe",
    testimonial:
      "Elevated Iron Guide has completely transformed my fitness journey. The support and knowledge shared by the community are unmatched!",
  },
  {
    name: "Emily Johnson",
    testimonial:
      "The workouts and guidance from Elevated Iron Guide are amazing. I've made significant progress, and the community makes it all the more motivating.",
  },
  {
    name: "Michael Smith",
    testimonial:
      "I joined Elevated Iron Guide to push myself further in my fitness goals. The advice and workouts are top-notch, and the community is incredibly supportive.",
  },
  {
    name: "Sarah Lee",
    testimonial:
      "I’ve never felt more confident in my fitness journey. Elevated Iron Guide provides fantastic resources and a community that lifts each other up!",
  },
  {
    name: "David Brown",
    testimonial:
      "The Elevated Iron Guide community is more than just a fitness group. It’s a place where you can learn, grow, and push yourself to new limits every day!",
  },
];

function Client() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageQueue, setImageQueue] = useState(images);
  const [hovered, setHovered] = useState(false);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % contantTest.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + contantTest.length) % contantTest.length
    );
  };

  useEffect(() => {
    if (!hovered) {
      const timeout = setTimeout(() => {
        nextSlide();
        setImageQueue((prevQueue) => {
          const newQueue = [...prevQueue];
          const movedImage = newQueue.shift(); // Remove the first image
          newQueue.push(movedImage); // Add it to the end
          return newQueue;
        });
      }, 3000); // Slide every 3 seconds

      return () => clearTimeout(timeout); // Cleanup timeout on each re-render
    }
  }, [imageQueue, hovered]);

  return (
    <div className="container-fluid our-client-says-container position-relative z-index-1 hw-100 pb-5 d-flex align-items-center">
      <img className="background-svg py-5" src={ClientsImg} alt="" />
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-6 col-md-6 my-auto py-2">
            <div className="client-says-left-content">
              <h2 className="fs-64  l-h-0-9 custom-color-blue fw-300">OUR </h2>
              <p className="fs-80 l-h-0-9 hc fw-700 l-height">CLIENT SAYS</p>
              <p className="text-white fs-18 l-h-1-3 fw-300">
                Borem ipsum dolor sit amet, consectetur adipiscing elit. ipsum
                dolor sit amet, consectetur adipiscing elit dolor Borem amet,
                consectetur
              </p>
            </div>
            <div className="client-says-testimonial  my-5">
              <div
                onMouseEnter={() => setHovered(true)} // Pause auto-slide on hover
                onMouseLeave={() => setHovered(false)} // Resume auto-slide when hover ends
                style={{
                  position: "relative",
                  width: "100%",
                  height: "300px",
                  overflow: "hidden",
                }}
                className={"testimonial-card rounded-5"}
              >
                <AnimatePresence>
                  <motion.div
                    key={currentIndex}
                    alt={`Slide ${currentIndex + 1}`}
                    initial={{ x: 300, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: -300, opacity: 0 }}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                    }}
                    className="  p-lg-5 p-4"
                  >
                    <p className="text-white fs-18 l-h-1-3 fw-300">
                      {contantTest.at(currentIndex).testimonial}
                    </p>
                    <div className="lower-card pt-4 d-flex align-items-center justify-content-between">
                      <h5 className=" fs-18 l-h-1-3 text-white fw-500">
                        {contantTest.at(currentIndex).name}
                      </h5>
                      <img className="rating-stars" src="stars.png" alt="" />
                    </div>
                  </motion.div>
                </AnimatePresence>
              </div>

              <div
                onMouseEnter={() => setHovered(true)} // Pause auto-slide on hover
                onMouseLeave={() => setHovered(false)} // Resume auto-slide when hover ends
                className="testimonial-image pt-5 d-flex justify-content-around align-items-center"
                style={{
                  position: "relative",
                  width: "100%",
                  height: "120px",
                }}
              >
                {imageQueue.map((image, index) =>
                  index === imageQueue.length - 1 ? ( // Skip animation for the last image
                    <img
                      key={image} // Use the image as the key for proper state tracking
                      src={image}
                      width="70px"
                      height="70px"
                      style={{
                        objectFit: "cover",
                        borderRadius: "50%",
                        border: "none", // Remove border for the last image
                        opacity: 0.3, // Set lower opacity for the last image
                        scale: 0.9,
                      }}
                    />
                  ) : (
                    <motion.div
                      key={image} // Use the image as the key for proper state tracking
                      style={{
                        position: "relative",
                        width: "70px",
                        height: "70px",
                        borderRadius: "35px",
                        overflow: "hidden",
                        borderColor: "#F2D378",
                        borderWidth: index === 0 ? "2px" : "0px",
                        borderStyle: "solid",
                      }}
                      initial={{
                        opacity:
                          index === 0 ? 1 : Math.max(1 - index * 0.25, 0.1), // Start hidden
                        scale: 0.8, // Start smaller
                        x: 20, // Start slightly shifted
                      }}
                      animate={{
                        opacity:
                          index === 0 ? 1 : Math.max(1 - index * 0.25, 0.1), // Fade in
                        scale: index === 0 ? 1.2 : 0.9, // The active image scales to full size
                        x: 0, // Slide into place
                      }}
                      transition={{
                        duration: 1, // Duration of the animation
                        ease: "easeInOut", // Smooth easing
                      }}
                    >
                      <img
                        src={image}
                        width="100%"
                        height="100%"
                        style={{
                          objectFit: "cover",
                          borderRadius: "50%", // Circle effect
                        }}
                      />
                    </motion.div>
                  )
                )}
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 py-2 text-lg-end text-center">
            <ShoulderPress />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Client;
